import { httpV2 } from "@/api";

const Qs = require("qs");

/**
 * Solicita os pontos do sinal bruto do diagnóstico em questão.
 * @param {object} parameters Parâmetros da requisição.
 */
const GetWaveform = ({ signalRegisterId, signalSettingIds }) =>
{
	const queryParams = {};
	queryParams.signalSettingIds = signalSettingIds;

	return httpV2.get(`/WindTurbinesDiagnostic/${signalRegisterId}/Waveform`, {
		params:           queryParams,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

export default { GetWaveform };